import { useState, useEffect } from "react";
import { Grid, TextField } from "@mui/material";

const Text = ({ question, onChange }) => {
  const [value, setValue] = useState(question.answer || "");

  // Re-sync if parent updates the answer (e.g. after a save round-trip).
  useEffect(() => {
    setValue(question.answer || "");
  }, [question.answer]);

  const isError = question.required && (value === "" || value === null);

  const commit = () => {
    const next = value || "";
    if (next === (question.answer || "")) return;
    onChange(question._id, next);
  };

  return (
    <Grid item xs={12}>
      <TextField
        fullWidth
        label={`${question.question}${question.required ? " *" : ""}`}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onBlur={commit}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            commit();
          }
        }}
        error={isError}
        helperText={
          isError
            ? "This field is required."
            : question.description || ""
        }
      />
    </Grid>
  );
};

export default Text;
